import React from 'react';

export default function EndPage({ ending, unlockedEndings, historyLog, onRestart, onShowModal, onShare }) {
  // 从结局文本中提取标题
  const getEndingTitle = (fullText) => {
    const match = fullText.match(/^(.*?：)/);
    return match ? match[1].replace('：', '') : "未知结局";
  };

  return (
    <div style={styles.containerIntro} className="no-select">
      <div style={{ textAlign: "center", animation: "fadeIn 1s" }}>
        <h1 style={{ color: '#f44336', letterSpacing: 2, margin: '0 0 10px 0', textShadow: '0 0 10px rgba(244,67,54,0.5)' }}>GAME OVER</h1>

        {/* ========================================== */}
        {/* 1. 本次结案报告 */}
        {/* ========================================== */}
        <div style={styles.card}>
          <div style={{ fontSize: 12, color: '#ff9800', marginBottom: 10 }}>[ 终局结案报告 ]</div>
          <h2 style={{ margin: 0, lineHeight: 1.5, fontSize: 16, color: '#fff' }}>{ending}</h2>
        </div>

        {/* ========================================== */}
        {/* 2. 赛博人生走马灯 (时光轴) */}
        {/* ========================================== */}
        {historyLog && historyLog.length > 0 && (
          <div style={{ marginTop: 20, textAlign: 'left', background: 'rgba(0,0,0,0.4)', padding: 15, borderRadius: 10, border: '1px solid #333' }}>
            <div style={{ fontSize: 13, color: '#aaa', marginBottom: 15, textAlign: 'center', letterSpacing: 2 }}>
              🎞️ 赛博人生走马灯 🎞️
            </div>

            <div style={{ maxHeight: '220px', overflowY: 'auto', paddingRight: 5, display: 'flex', flexDirection: 'column', gap: 12, scrollbarWidth: 'thin' }}>
              {[...historyLog].reverse().map((log, idx) => {
                const nodeColor = log.san <= 20 ? '#f44336' : log.san <= 40 ? '#ff9800' : '#4caf50';
                return (
                  <div key={idx} style={{ paddingLeft: 12, borderLeft: '2px solid #333', position: 'relative' }}>
                    <div style={{ position: 'absolute', left: -5, top: 4, width: 8, height: 8, borderRadius: '50%', background: nodeColor, boxShadow: `0 0 8px ${nodeColor}` }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 10, color: '#888' }}>第 {log.round} 周</span>
                      <span style={{ fontSize: 10, color: nodeColor }}>San: {log.san}</span>
                    </div>
                    <div style={{ fontSize: 13, color: '#eee', fontWeight: 'bold', margin: '4px 0' }}>{log.eventTitle}</div>
                    <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic', lineHeight: 1.4 }}>
                      » {log.choiceText.replace(/【.*?】/, '')}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}

        {/* ========================================== */}
        {/* 3. 成就墙：历史解锁结局 */}
        {/* ========================================== */}
        <div style={{ marginTop: 20, textAlign: 'left' }}>
          <div style={{ fontSize: 13, color: '#888', marginBottom: 10, display: 'flex', justifyContent: 'space-between' }}>
            <span>🏆 已解锁的平行宇宙</span>
            <span>{unlockedEndings?.length || 1} / 8</span>
          </div>

          <div style={styles.achievementsGrid}>
            {unlockedEndings && unlockedEndings.map((endText, index) => (
              <div key={index} style={styles.achievementBadge}>
                {getEndingTitle(endText)}
              </div>
            ))}
          </div>
        </div>

        {/* ========================================== */}
        {/* 🌟 4. 新增：底部行动按钮组 */}
        {/* ========================================== */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 30 }}>
          <button style={styles.btnPrimary} onClick={onRestart}>
            🔄 带着记忆重新投胎
          </button>

          <div style={{ display: 'flex', gap: 12 }}>
            <button style={styles.btnSecondary} onClick={onShare}>
              📢 转发炫耀
            </button>
            {/* 🌟 点击直接触发全局弹窗，不跳出网页 */}
            <button style={styles.btnDonate} onClick={() => onShowModal('donate')}>
              ☕ 投喂开发者
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}

const styles = {
  containerIntro: { maxWidth: 460, margin: "5vh auto", padding: 25, background: "#121212", color: "#eee", borderRadius: 12, maxHeight: '90vh', overflowY: 'auto', scrollbarWidth: 'none' },
  card: { background: "#1e1e1e", padding: "20px", borderRadius: 10, border: '1px solid #333' },
  achievementsGrid: { display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 },
  achievementBadge: { background: 'rgba(255, 152, 0, 0.15)', border: '1px solid #ff9800', color: '#ffb74d', padding: '6px 10px', borderRadius: 6, fontSize: 12, fontWeight: 'bold', animation: 'popUp 0.5s ease-out' },

  // 按钮样式
  btnPrimary: { width: "100%", padding: 14, background: "#ff9800", color: "#000", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 15, fontWeight: 'bold', transition: '0.2s', boxShadow: '0 4px 15px rgba(255,152,0,0.3)' },
  btnSecondary: { flex: 1, padding: 12, background: "#2196f3", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 14, fontWeight: 'bold', transition: '0.2s' },
  btnDonate: { flex: 1, padding: 12, background: "transparent", color: "#4caf50", border: "1px solid #4caf50", borderRadius: 8, cursor: "pointer", fontSize: 14, fontWeight: 'bold', transition: '0.2s' }
};